import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import App from './App';
import GravityCollector from '@smartesting/gravity-data-collector/dist';
import { HostPlatform } from './config/hostPlatform';

if (HostPlatform.isAzure() && process.env.REACT_APP_GRAVITY_API_KEY) {
  GravityCollector.init({
    authKey: process.env.REACT_APP_GRAVITY_API_KEY,
    cookieStrategy: 'iframeEmbedding',
  });
}

const container = document.querySelector('#root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      retry: 3,
    },
  },
});

const queryString = window.location.search;
const urlParameters = new URLSearchParams(queryString);
const isAdminEntryPoint = urlParameters.get('isAdminEntryPoint') === 'true';

root.render(
  <QueryClientProvider client={queryClient}>
    <App isAdminEntryPoint={isAdminEntryPoint} />
  </QueryClientProvider>
);
